import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Grid,
  Typography,
} from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { Images } from "../../../../helpers/Images";
import { Q_FreeStyle, categoriesData } from "../../../../helpers/Arrays";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const FreeStyleTemplate = () => {
  const navigate = useNavigate();
  return (
    <>
      <Box
        sx={{
          width: "100%",
          padding: { xs: "50px 20px", sm: "50px 60px", lg: "50px 120px" },
          maxWidth: "1500px",
          margin: "auto",
        }}
      >
        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <Typography
              variant={"h1"}
              sx={{
                textAlign: "start",
                fontSize: { xs: "40px", sm: "55px" },
                fontWeight: "500",
                color: "primary.darker",
              }}
            >
              Free Style
            </Typography>
            <Box
              sx={{
                height: "3px",
                maxWidth: { xs: "100px", md: "150px" },
                width: "100%",
                backgroundColor: "primary.main",
                margin: "10px 0 0 0",
              }}
            />
            <Typography
              sx={{
                textAlign: "left",
                color: "primary.darker",
                maxWidth: "750px",
                margin: "25px auto 10px auto",
                fontSize: "17px",
              }}
            >
              <span style={{ fontWeight: "700", color: "#830d0b" }}>Age:</span>{" "}
              9-24 <br />
              <span style={{ fontWeight: "700", color: "#830d0b" }}>
                Team size:
              </span>{" "}
              1-5 people guided by a coach <br />
              <span style={{ fontWeight: "700", color: "#830d0b" }}>
                Area of development:
              </span>
              <br />
              - Research and development: Identify a specific problem within the
              season research and come up with creative solution. <br />
              - Prototyping: Turning your idea into functional robot solution
              <br />
              - Technical engineering skills: Using sensors and motors to make
              robot design solve problem <br />
              - Innovation <br />
              - Presentation skills
              <br />
              {/* <span style={{ fontWeight: "700", color: "#830d0b" }}>
                Hardware:
              </span>{" "}
              LEGO® based
              <br />
              <span style={{ fontWeight: "700", color: "#830d0b" }}>
                Software:
              </span>{" "}
              Free choice <br /> */}
              {/* <span style={{ fontWeight: "700", color: "#830d0b" }}>
                Maximum size:
              </span>{" "}
              Max. 20 x 20 x 20 cm */}
              {/* <br />
              <span style={{ fontWeight: "700", color: "#830d0b" }}>
                Characteristics:
              </span>{" "}
              Teams design 2 robots that compete with robots of another team.{" "} */}
              <br />
              <br />
              <Box
                sx={{
                  height: "3px",
                  width: "100%",
                  backgroundColor: "primary.main",
                }}
              />
              <br />
              In Robotchallenge freestyle category teams develop a robot,
              control circuit or embedded system that helps to solve real-world
              problems. Each team develops an innovative and functioning robotic
              solution. They present their project in the competition day.
            </Typography>
            <br />
            <Box
              sx={{
                height: "3px",
                width: "100%",
                backgroundColor: "primary.main",
              }}
            />
            <br />
            <Typography
              sx={{
                // textAlign: "center",
                maxWidth: "750px",
                // margin: "auto",
                fontSize: "22px",
              }}
            >
              <a
                download
                href={
                  "https://drive.google.com/uc?export=download&id=1SzB-PXbRWxGAvRYMp3Vqc_0Sqhsm3CWv"
                }
              >
                <Button
                  variant="contained"
                  color="primary"
                  sx={{
                    fontSize: "17px",
                    fontWeight: "600",
                    backgroundColor: "primary.main",
                  }}
                >
                  Download Detailed Rules ( PDF )
                </Button>
              </a>
            </Typography>
            <Typography
              sx={{
                // textAlign: "center",
                maxWidth: "750px",
                // margin: "auto",
                fontSize: "22px",
              }}
            >
              <a
                download
                href={
                  "https://drive.google.com/uc?export=download&id=1YT4BbAQv5487mSZdHReZOFP2swcL_as6"
                }
              >
                <Button
                  variant="contained"
                  color="primary"
                  sx={{
                    fontSize: "17px",
                    fontWeight: "600",
                    backgroundColor: "primary.main",
                    marginTop: "10px",
                  }}
                >
                  Download Scoring Sheet ( PDF )
                </Button>
              </a>
            </Typography>
            <Box
            // sx={{ width: "100%", display: "flex", justifyContent: "center" }}
            >
              <Button
                variant="contained"
                color="primary"
                sx={{
                  fontSize: "17px",
                  margin: "10px 0",
                  fontWeight: "600",
                  backgroundColor: "primary.main",
                }}
                onClick={() => navigate("/firststage")}
              >
                Register Now
              </Button>
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <img
              alt="freestyle"
              src={Images.freeStyle}
              style={{ width: "100%", borderRadius: "10px" }}
            />
          </Grid>
        </Grid>
      </Box>
      <Box
        sx={{
          width: "100%",
          padding: { xs: "50px 20px", sm: "50px 60px", lg: "50px 120px" },
          maxWidth: "1500px",
          margin: "auto",
        }}
      >
        <Typography
          variant={"h1"}
          sx={{
            textAlign: "start",
            fontSize: { xs: "40px" },
            fontWeight: "500",
            color: "primary.darker",
          }}
        >
          Questions & Answers
        </Typography>
        <Box
          sx={{
            height: "3px",
            maxWidth: { xs: "100px", md: "200px" },
            width: "100%",
            backgroundColor: "primary.main",
            margin: "10px 0 0 0",
          }}
        />
        <Box id={"questions"} sx={{ marginTop: "50px" }}>
          {Q_FreeStyle.map((item) => (
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography>{item.question}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>{item.answer}</Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Box>
      </Box>
      <Box
        sx={{
          width: "100%",
          backgroundColor: "primary.main",
        }}
      >
        <Box
          sx={{
            width: "100%",
            padding: { xs: "50px 20px", sm: "50px 60px", lg: "50px 120px" },
            maxWidth: "1500px",
            margin: "auto",
          }}
        >
          <Typography
            variant={"h2"}
            sx={{
              textAlign: "center",
              fontSize: { xs: "40px" },
              fontWeight: "500",
              color: "secondary.main",
            }}
          >
            Our All Categories
          </Typography>
          <Box
            sx={{
              height: "3px",
              maxWidth: { xs: "100px", md: "150px" },
              width: "100%",
              backgroundColor: "secondary.main",
              margin: "10px auto 0 auto",
            }}
          />
          <Grid
            container
            spacing={2}
            sx={{ marginTop: "50px", justifyContent: "center" }}
          >
            {categoriesData
              ?.filter((category) => category.title !== "FreeStyle")
              ?.map((item) => (
                <Grid item xs={12} sm={6} md={3}>
                  <Box
                    sx={{
                      backgroundImage: `linear-gradient(0deg, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.5)), url(${item.image})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "flex-end",
                      width: "100%",
                      minHeight: { xs: "200px", sm: "250px" },
                      borderRadius: "10px",
                    }}
                  >
                    <Typography
                      variant={"h3"}
                      sx={{
                        textAlign: "center",
                        fontSize: "35px",
                        fontWeight: "500",
                        color: "secondary.main",
                      }}
                    >
                      {item.title}
                    </Typography>
                    <Box
                      sx={{
                        height: "3px",
                        maxWidth: "90px",
                        width: "100%",
                        backgroundColor: "secondary.main",
                        margin: "5px auto 5px auto",
                      }}
                    />
                    <Box
                      sx={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <Button
                        variant="contained"
                        color="secondary"
                        sx={{
                          fontSize: "13px",
                          fontWeight: "600",
                          color: "primary.main",
                          width: "fit-content",
                          margin: { xs: "5px 0 20px 0", sm: "10px 0 40px 0" },
                        }}
                        onClick={() => navigate(item.link)}
                      >
                        view
                      </Button>
                    </Box>
                  </Box>
                </Grid>
              ))}
          </Grid>
        </Box>
      </Box>
    </>
  );
};

export default FreeStyleTemplate;
